const refurbishmentInfo = document.querySelector('.refirblishment-info-wrp');
const parallaxSection = document.querySelector('.sustainability-commitment-parallax');

if (parallaxSection) {
  const parallaxOverlay = parallaxSection.querySelector('.parallax-white-overlay');
  const text = parallaxSection.querySelector('.text');
  const clouds = parallaxSection.querySelector('.clouds');
  const mountain = parallaxSection.querySelector('.mountain');

  let sectionTop = 0;
  let sectionHeight = 0;
  let latestScrollY = window.scrollY || window.pageYOffset;
  let frameRequested = false;
  let isMobile = window.innerWidth < 768;

  const resetParallaxStyles = () => {
    if (text) {
      text.style.transform = '';
    }
    if (clouds) {
      clouds.style.transform = '';
    }
    if (mountain) {
      mountain.style.transform = '';
    }
    if (refurbishmentInfo) {
      refurbishmentInfo.style.marginTop = '';
    }
    if (parallaxOverlay) {
      parallaxOverlay.style.opacity = '';
    }
  };

  const recalcSectionMetrics = () => {
    // Cache expensive geometry reads to keep scroll handling cheap on mobile.
    const rect = parallaxSection.getBoundingClientRect();
    const scrollY = window.scrollY || window.pageYOffset;
    sectionTop = rect.top + scrollY;
    sectionHeight = rect.height;
  };

  const runParallaxFrame = () => {
    frameRequested = false;

    if (isMobile) {
      resetParallaxStyles();
      return;
    }

    const localScroll = Math.min(Math.max(latestScrollY - sectionTop, 0), sectionHeight);

    if (text) {
      text.style.transform = `translate(-50%, ${localScroll * 0.2}px)`;
    }
    if (clouds) {
      clouds.style.transform = `translateY(-${localScroll * 0.5}px)`;
    }
    if (mountain) {
      mountain.style.transform = `translateY(-${localScroll * 0.2}px)`;
    }

    if (refurbishmentInfo) {
      refurbishmentInfo.style.marginTop = `-${localScroll * 0.6}px`;
    }

    if (parallaxOverlay) {
      const overlayStart = window.innerWidth < 768 ? 100 : 300;
      const opacity = localScroll > overlayStart ? Math.min((localScroll - overlayStart) / 150, 1) : 0;
      parallaxOverlay.style.opacity = opacity;
    }
  };

  const requestParallaxFrame = () => {
    if (isMobile) {
      return;
    }

    latestScrollY = window.scrollY || window.pageYOffset;
    if (!frameRequested) {
      frameRequested = true;
      window.requestAnimationFrame(runParallaxFrame);
    }
  };

  const handleResize = () => {
    isMobile = window.innerWidth < 768;
    recalcSectionMetrics();

    if (isMobile) {
      resetParallaxStyles();
      return;
    }

    requestParallaxFrame();
  };

  recalcSectionMetrics();
  window.addEventListener('scroll', requestParallaxFrame, { passive: true });
  window.addEventListener('resize', handleResize);

  if (isMobile) {
    resetParallaxStyles();
  } else {
    requestParallaxFrame();
  }
}
